import React from "react";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import './styles.scss';
import stringJp from '../../../constants/stringJP';

const AddMember = (props) => {

  const { account_id } = props;
  let history = useHistory();

  const handleClick = (account_id) => {
    history.push(`/add-member?account_id=${account_id}`)
  };

  return (
    <div
      className="btnAddMember"
      style={{ margin: "2px 17px 10px 17px", textAlign: "right", marginTop: 5 }}>
      <Button
        variant="contained"
        component="span"
        className="add"
        onClick={() => handleClick(account_id)}
      >
        <div className="btn-add">{stringJp.label_add_memeber}</div>
      </Button>

    </div>
  );
};
export { AddMember };
